function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var plugin = require('tailwindcss/plugin');

var aspectRatio = plugin(function (_ref) {
  var _ref6;

  var addComponents = _ref.addComponents,
      theme = _ref.theme,
      variants = _ref.variants,
      e = _ref.e;
  var values = theme('aspectRatio');
  var baseSelectors = Object.entries(values).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    return ".".concat(e("aspect-w-".concat(key)));
  }).join(',\n');
  var childSelectors = Object.entries(values).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        key = _ref5[0],
        value = _ref5[1];

    return ".".concat(e("aspect-w-".concat(key)), " > *");
  }).join(',\n');
  addComponents([(_ref6 = {}, _defineProperty(_ref6, baseSelectors, {
    position: 'relative',
    paddingBottom: "calc(var(--tw-aspect-h) / var(--tw-aspect-w) * 100%)"
  }), _defineProperty(_ref6, childSelectors, {
    position: 'absolute',
    height: '100%',
    width: '100%',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0'
  }), _defineProperty(_ref6, '.aspect-none', {
    position: 'static',
    paddingBottom: '0'
  }), _defineProperty(_ref6, '.aspect-none > *', {
    position: 'static',
    height: 'auto',
    width: 'auto',
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
  }), _ref6), Object.entries(values).map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        key = _ref8[0],
        value = _ref8[1];

    return _defineProperty({}, ".".concat(e("aspect-w-".concat(key))), {
      '--tw-aspect-w': value
    });
  }), Object.entries(values).map(function (_ref10) {
    var _ref11 = _slicedToArray(_ref10, 2),
        key = _ref11[0],
        value = _ref11[1];

    return _defineProperty({}, ".".concat(e("aspect-h-".concat(key))), {
      '--tw-aspect-h': value
    });
  })], variants('aspectRatio'));
}, {
  theme: {
    aspectRatio: {
      1: '1',
      2: '2',
      3: '3',
      4: '4',
      5: '5',
      6: '6',
      7: '7',
      8: '8',
      9: '9',
      10: '10',
      11: '11',
      12: '12',
      13: '13',
      14: '14',
      15: '15',
      16: '16'
    }
  },
  variants: {
    aspectRatio: ['responsive']
  }
});
module.exports = aspectRatio;